module.exports = __webpack_public_path__ + "img/Kuchen.8c56d794.svg";